import type { BoardLegendItem } from "./legendTypes";

/** Local backup of the current hard-coded chips. Used when the DB is empty. */
export const FALLBACK_LEGEND: BoardLegendItem[] = [
  {
    token: "biz.guanxin",
    layer: "biz",
    line_key: "gx",
    label: "观心微语",
    description: null,
    sort_order: 10,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#DB7A00",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#C47B12",
    soft_chip_bg: "#F6D7A4",
    soft_chip_text: "#5C2E00",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "biz.tuwen",
    layer: "biz",
    line_key: "tw",
    label: "小凡的图文故事",
    description: null,
    sort_order: 20,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#5856D6",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#1565B8",
    soft_chip_bg: "#C5DDF8",
    soft_chip_text: "#0A335C",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "biz.caogao",
    layer: "biz",
    line_key: "cg",
    label: "小凡的草稿本",
    description: null,
    sort_order: 30,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#8E8E93",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#5E5A52",
    soft_chip_bg: "#E3DFD4",
    soft_chip_text: "#2A2722",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "biz.dushubiji",
    layer: "biz",
    line_key: "xyz",
    label: "小凡的读书笔记",
    description: null,
    sort_order: 40,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#7B3FA8",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#7B3FA8",
    soft_chip_bg: "#E6D0F4",
    soft_chip_text: "#4A1570",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "biz.cosytab",
    layer: "biz",
    line_key: "cosy",
    label: "CosyTab",
    description: null,
    sort_order: 50,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#0E7C78",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#0E7C78",
    soft_chip_bg: "#B7E8E4",
    soft_chip_text: "#084440",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "biz.geo",
    layer: "biz",
    line_key: "geo",
    label: "GEO",
    description: null,
    sort_order: 60,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#D17A1A",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#D17A1A",
    soft_chip_bg: "#F8D7B0",
    soft_chip_text: "#6A3808",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    // Opened line. DESIGN_TOKENS has no niuma swatch; #007AFF is unused
    // system blue, distinct from 图文 #5856D6 and CosyTab #0E7C78.
    // Product ideas are not opened lines — only 童心会话视频 stays dashed.
    token: "biz.niuma",
    layer: "biz",
    line_key: "nm",
    label: "打工牛马连连看",
    description: null,
    sort_order: 65,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#007AFF",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#0A5FBF",
    soft_chip_bg: "#C5DCF8",
    soft_chip_text: "#08315C",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "idea.tongxin",
    layer: "idea",
    line_key: "idea",
    label: "童心会话视频",
    description: null,
    sort_order: 80,
    show_in_legend: true,
    visual_style: "dashed",
    bar_hex: null,
    bar_text_hex: null,
    outline_hex: "#C4A574",
    outline_text_hex: "#5B4A2A",
    soft_dot_hex: null,
    soft_chip_bg: null,
    soft_chip_text: null,
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "matter.jiaoliu",
    layer: "matter",
    line_key: "you",
    label: "交流",
    description: null,
    sort_order: 90,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#FF3B30",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#C62828",
    soft_chip_bg: "#F7C6C6",
    soft_chip_text: "#7A1010",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "matter.gongsi",
    layer: "matter",
    line_key: "co",
    label: "公司事项",
    description: null,
    sort_order: 100,
    show_in_legend: true,
    visual_style: "solid",
    bar_hex: "#2AA84A",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#1B7A45",
    soft_chip_bg: "#B6E8CE",
    soft_chip_text: "#084028",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
  {
    token: "matter.morun",
    layer: "matter",
    line_key: "soft",
    label: "默跑",
    description: null,
    sort_order: 110,
    show_in_legend: false,
    visual_style: "solid",
    bar_hex: "#737373",
    bar_text_hex: "#FFFFFF",
    outline_hex: null,
    outline_text_hex: null,
    soft_dot_hex: "#737373",
    soft_chip_bg: "#E7E7E7",
    soft_chip_text: "#2C2C2C",
    links: [],
    mac_account_path: null,
    active: true,
    source: "fallback",
  },
];
